// Global Instructions Rule Applied!

import {
  SET_GLOBAL_CONFIGS,
  CLEAR_GLOBAL_CONFIGS_DATA,
  REMOVE_USER_PREFERENCE_FOR_MENU_ITEM,
  MERGE_USER_PREFERENCE_ROW_DATA,
  SET_USER_PREFERENCES_APP_DATA,
  UPDATE_GLOBAL_CONFIG_FUND,
  ADD_GLOBAL_CONFIG_FUND
} from './constants.ts'
import { GlobalConfigsAction, GlobalConfigsState } from '../../interfaces/global_configs.ts'

const globalConfigsReducer = (
  state: GlobalConfigsState = {
    lookup_headers: [],
    countries: [],
    currencies: [],
    pipeline_stages: [],
    pipelines: [],
    pipeline_configs: [],
    funds: [],
    fund_statuses: [],
    fundraising_default_fund_id: null,
    account_role_choices: [],
    investor_classifications: [],
    sbic_investor_types: [],
    share_registers: [],
    relationship_categories: [],
    relationship_types: [],
    comms_topics: [],
    comms_lp_statuses: [],
    comms_lp_status_rules: [],
    comms_topic_roles: [],
    menu_sections: [],
    menu_categories: [],
    menu_items: [],
    user_preferences_reports: [],
    user_preferences_app: null,
    reporting_column_types: [],
    modules: [],
    reporting_configs: [],
    reporting_modules: [],
    reporting_column_defaults: [],
    reporting_columns: [],
    reporting_default_sorts: [],
    time_units: [],
    reference_date_types: [],
    gp_commitment_bases: [],
    fee_bases: [],
    fee_reduction_schemes: [],
    compounding_frequencies: [],
    day_count_conventions: [],
    interest_payment_types: [],
    fund_transaction_types: [],
    acc_items: [],
    current_user: null
  },
  action: GlobalConfigsAction
): GlobalConfigsState => {
  switch (action.type) {
    case SET_GLOBAL_CONFIGS:
      const { global_configs } = action.payload

      return {
        ...global_configs
      }

    case CLEAR_GLOBAL_CONFIGS_DATA:
      return {
        lookup_headers: [],
        countries: [],
        currencies: [],
        pipeline_stages: [],
        pipelines: [],
        pipeline_configs: [],
        funds: [],
    fund_statuses: [],
    fundraising_default_fund_id: null,
        account_role_choices: [],
        investor_classifications: [],
        sbic_investor_types: [],
        relationship_categories: [],
        relationship_types: [],
        comms_topics: [],
        comms_lp_statuses: [],
        comms_lp_status_rules: [],
        comms_topic_roles: [],
        menu_sections: [],
        menu_categories: [],
        menu_items: [],
        user_preferences_reports: [],
        // Explicit on logout: without the wipe, the next user signing in on
        // the same tab briefly inherits the previous user's stored area.
        user_preferences_app: null,
        reporting_column_types: [],
        modules: [],
        reporting_configs: [],
        reporting_modules: [],
        reporting_column_defaults: [],
        reporting_columns: [],
        reporting_default_sorts: [],
        current_user: null
      }

    case REMOVE_USER_PREFERENCE_FOR_MENU_ITEM: {
      const { menu_item_id } = action.payload
      return {
        ...state,
        user_preferences_reports: (state.user_preferences_reports ?? []).filter(
          (p) => p.menu_item_id !== menu_item_id
        )
      }
    }

    case ADD_GLOBAL_CONFIG_FUND: {
      const { fund } = action.payload
      const existing = (state.funds ?? []).filter((f: any) => f && f.id !== fund.id)
      return { ...state, funds: [fund, ...existing] }
    }

    case UPDATE_GLOBAL_CONFIG_FUND: {
      const { fund_id, updates } = action.payload
      return {
        ...state,
        funds: (state.funds ?? []).map((fund: any) =>
          fund && fund.id === fund_id ? { ...fund, ...updates } : fund
        )
      }
    }

    case MERGE_USER_PREFERENCE_ROW_DATA: {
      const { menu_item_id, data } = action.payload
      const rows = [...(state.user_preferences_reports ?? [])]
      const idx = rows.findIndex((p) => p.menu_item_id === menu_item_id)
      if (idx < 0) return state
      rows[idx] = { ...rows[idx], data: { ...data } }
      return { ...state, user_preferences_reports: rows }
    }

    case SET_USER_PREFERENCES_APP_DATA: {
      // Upsert, not merge-if-present: the row may not exist yet, and bailing
      // out (as MERGE_USER_PREFERENCE_ROW_DATA does) would force a full
      // global-configs refetch on the very first write of a preference.
      const { data } = action.payload
      const existing = state.user_preferences_app
      return {
        ...state,
        user_preferences_app: {
          user_id: existing?.user_id ?? '',
          data: { ...(existing?.data ?? {}), ...data }
        }
      }
    }

    default:
      return state
  }
}

export default globalConfigsReducer
export * from './actions.ts'
